import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PlanbookView } from "@shared/models/analytics/planbook"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import createNarrative from "../create-narrative"

interface Payload {
  routeName: string
  planbookId: string
  queryParams: object
}

export default function planbookViewAction(payload: Payload): PreparedAction {
  return {
    name: "PLANBOOK_VIEW",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let routeName
  let primaryObjectSpecifier
  if (payload.routeName === "planbookv5.planner.day") {
    routeName = "planbook.show.planner.day"
    primaryObjectSpecifier = "day"
  } else if (payload.routeName === "planbookv5.planner.week") {
    routeName = "planbook.show.planner.week"
    primaryObjectSpecifier = "week"
  } else if (payload.routeName === "planbookv5.planner.month") {
    routeName = "planbook.show.planner.month"
    primaryObjectSpecifier = "month"
  } else if (payload.routeName === "planbookv5.planner.timeline") {
    routeName = "planbook.show.planner.units"
    primaryObjectSpecifier = "timeline"
  } else if (payload.routeName === "planbookv5.planner.outline") {
    routeName = "planbook.show.planner.outline"
    primaryObjectSpecifier = "outline"
  } else if (payload.routeName === "planbookv5.sharing") {
    routeName = "planbook.show.collaborate"
    primaryObjectSpecifier = "sharing"
  } else if (payload.routeName === "planbookv5.class-websites") {
    routeName = "planbook.show.class-websites"
    primaryObjectSpecifier = "class_websites"
  } else if (payload.routeName === "planbookv5.standards-tracker") {
    routeName = "planbook.show.standards-tracker"
    primaryObjectSpecifier = "standards_tracker"
  } else if (payload.routeName === "planbookv5.search") {
    routeName = "planbookv5.search"
    primaryObjectSpecifier = "search_page"
  }

  let newEvent: PlanbookView = {
    ...createBlankEvent(),
    root_id: payload.planbookId,
    root_type: "planbook",
    primary_object_type: "planbook",
    primary_possessive: "owns",
    primary_object_id_and_ancestor_ids: [payload.planbookId],
    primary_verb: "view",
    primary_object_specifier: primaryObjectSpecifier,
    adverbial_verb: null,
    adverbial_object_type: null,
    adverbial_object_specifier: null,
  }
  return createNarrative({
    title: `Navigated to ${routeName}`,
    titleForAnalytics: "Page - Visit",
    description: `Navigated to ${routeName}`,
    context: { routeName: routeName, ...payload.queryParams },
    newAnalyticsEvents: [newEvent],
  })
}
